
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/matkaajat",
      function () {
        return require("private-next-pages/matkaajat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/matkaajat"])
      });
    }
  